import defaultClient from 'common-axios';

const fetcher = (client = defaultClient) => async (...args) => {
  const res = await client(...args);
  return res.data;
};

export default fetcher;
